import { useRoute, useRouter } from 'vue-router';

export const useUrlParams = () => {
    const route = useRoute();
    const router = useRouter();

    const addParam = async (key: string, value: string) => {
       await router.push({ query: { ...route.query, [key]: value } });
    };

    const getParam = (key: string) => {
        return route.query[key];
    };

    const removeParam = async (key: string) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { [key]: _, ...query } = route.query;
        await router.push({ query });
    };

    return { addParam, getParam, removeParam };
};
